/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ProposalViewModel } from './ProposalViewModel';
import {
    ProposalViewModelFromJSON,
    ProposalViewModelFromJSONTyped,
    ProposalViewModelToJSON,
} from './ProposalViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfProposalViewModel
 */
export interface ResultOfProposalViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfProposalViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfProposalViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfProposalViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfProposalViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfProposalViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfProposalViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfProposalViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {ProposalViewModel}
     * @memberof ResultOfProposalViewModel
     */
    data?: ProposalViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfProposalViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfProposalViewModel interface.
 */
export function instanceOfResultOfProposalViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfProposalViewModelFromJSON(json: any): ResultOfProposalViewModel {
    return ResultOfProposalViewModelFromJSONTyped(json, false);
}

export function ResultOfProposalViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfProposalViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : ProposalViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfProposalViewModelToJSON(value?: ResultOfProposalViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': ProposalViewModelToJSON(value.data),
        'Count': value.count,
    };
}

